import { useState, useMemo } from 'react';

function useToggleState(initialState = false) {
  const [isToggled, setToggled] = useState(initialState);
  const actions = useMemo(() => ({
    enable: () => {
      setToggled(true);
    },
    disable: () => {
      setToggled(false);
    },
    toggle: () => {
      setToggled(prev => !prev);
    }
  }), []);
  return useMemo(() => [isToggled, actions], [actions, isToggled]);
}

export { useToggleState };
//# sourceMappingURL=toggle-state.js.map
